import React from 'react'
import { css, Global, withTheme } from '@emotion/react'

const GlobalStyles = withTheme(() => <Global styles={css``} />)

export default GlobalStyles
